import Button from '@/components/button';
import { ChevronLeftIcon } from '@/components/ui/icons';

interface ProductDrawerBackBtnProps {
  callback: () => void;
  text: string;
}

export const ProductDrawerBackBtn = ({ callback, text }: ProductDrawerBackBtnProps) => {
  return (
    <div className="justify-between items-center">
      <Button
        variant="text"
        color="primary"
        className="px-0"
        onClick={callback}
        startIcon={<ChevronLeftIcon />}
      >
        {text}
      </Button>
    </div>
  );
};
